import Vuetify from 'vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

import Vue from 'vue'

import App from './App.vue'
import router from './router'
import filters from './filters'
import 'babel-polyfill'
import './registerServiceWorker'
import fb from './firebaseConfig.js'
import { store } from './store.js'

import moment from 'moment'
import vueMoment from 'vue-moment'
import lodash from 'lodash'

import AgencesList from '@/components/AgencesList'
import ColorIndicator from '@/components/ColorIndicator'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
 
Vue.use(Vuetify, {
  theme: {
    primary: '#C31635',
    secondary: '#b08838',
    accent: '#3F51B5'
  }
})
Vue.use(filters)
Vue.use(vueMoment, { moment })

Vue.component('AgencesList', AgencesList)
Vue.component('ColorIndicator', ColorIndicator)
Vue.component('ChartJsPluginDataLabels', ChartJsPluginDataLabels)

Vue.config.productionTip = false
Vue.prototype.$fb = fb
Vue.prototype.$lodash = lodash

// handle page reloads
let app
// eslint-disable-next-line
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    new Vue({
      router,
      store,
      mounted() {
        this.$moment.locale('fr')
      },
      render: h => h(App),
    }).$mount('#app')
  }
})

